import { action, Action } from 'typesafe-actions'

import { ContatoTypes } from './types'

export const setTelefone = (payload: string): Action => action(ContatoTypes.SET_TELEFONE, payload)

export const setEmail = (payload: string): Action => action(ContatoTypes.SET_EMAIL, payload)
